import { createApp } from "vue";
import App from "./src/App.vue";
import "./magnetograms-tracker.module.scss";
import { defineApp } from "../../../utilities/vue-app-kit";
defineApp({
    name: "magnetograms-tracker",
    globalName: "LmuMagnetogramsTracker",
    validateFn: (config) => Boolean(config.baseUrl),
    mountFn: ({ el, config }) => {
        const app = createApp(App);
        app.provide("config", config);
        app.mount(el);
    }
});
